import React from "react";

const Card4 = ({qrCodeRef, logo, profile, candidateName, studentAdmission, studentClass, studentSection, qrData, fathersName, schoolName, mobile, schoolMobile, schoolAddress}) => {
  return (
    <div class="addd-container " ref={qrCodeRef}>
      <div class="id-card">
        <div class="addschool-logo text-center">
          <h4>{schoolName}</h4>
        </div>

        <div class="addd-row text-center mt-2" style={{marginTop: 10, marginBottom:10}}>
          <div class="col-6">
            <div class="photo-frame1">
              <img src={profile} alt="Profile" />
            </div>
          </div>
          <div class="col-6">
            <div class="photo-frame2">
              <img src={logo} alt="Profile" className="add-schoollogo" />
            </div>
          </div>
        </div>

        <div class="student-info">
          <h5>{candidateName}</h5>
          <p>
            <strong>Father's Name:</strong> {fathersName}
          </p>
          <p>
            <strong>Class:</strong> {studentClass} - {studentSection}
          </p>
          <p>
            <strong>Contact No.:</strong> {mobile}
          </p>
        </div>

        <div class="barcode">
          <img
            src={qrData}
            alt="Profile"
            X
            style={{
              width: 100,
              marginTop: "10px",
              marginBottom: "10px",
            }}
          />
        </div>

        <div class="addd-footer text-center mt-1">
          <p>{schoolName} | Ph: {schoolMobile}</p>
          <p style={{fontSize: 12}}>{schoolAddress}</p>
        </div>
      </div>
    </div>
  );
};

export default Card4;
